module.exports = __webpack_public_path__ + "img/steel-angles-card.f9b146e3.jpg";